import v38Schema from '../client/schemaVersions/v38.js';
import v39Schema from '../client/schemaVersions/v39.js';
import { createMigration } from '@verdant-web/store';
export default createMigration(v38Schema, v39Schema);
//# sourceMappingURL=v39.js.map